<script>
export default {
    props: ['playing', 'mode', 'nowMaxFrame', 'nowFrame', 'nowID', 'allBalls', 'nonBottom'],
    emits: ['single-pitch', 'multi-pitch', 'single-slow', 'multi-slow', 'range-input', 'next', 'prev'],
    computed: {
        allBallsLength () {
            let result = 0
            if (this.allBalls !== null && typeof this.allBalls !== 'undefined') {
                result = this.allBalls.length
            }
            return result
        },
        localNowFrame: {
            get () {
                return this.nowFrame
            },
            set (value) {
                if (value >= 0 && value <= this.nowMaxFrame) {
                    this.$emit('range-input', value)
                }
            }
        }
    },
    methods: {
        singlePitch (index) {
            this.$emit('single-pitch', index)
        },
        multiPitch () {
            this.$emit('multi-pitch')
        },
        singleSlow () {
            this.$emit('single-slow')
        },
        multiSlow () {
            this.$emit('multi-slow')
        },
        rangeInput () {
            this.$emit('range-input')
        },
        next () {
            this.$emit('next')
        },
        prev () {
            this.$emit('prev')
        },
        invalidPinch (e) {
            e.preventDefault()
        }
    }
}
</script>
